import React, {useEffect} from 'react';
import {useTitle} from "../../../contexts/title";
import UserGrid from '../../../features/cfi/user-grid/components/UserGrid';

export default function UsersPage() {

	const pageTitle = useTitle();
	useEffect(() => {
		pageTitle.setTitle('Users')
	}, [pageTitle]);

	return (
		<React.Fragment>
			<div className={'content-block'}>
				<UserGrid />
			</div>
		</React.Fragment>
	)
} 
